import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import InboxManagerMixin from '@/helpers/vue_mixins/v3/copilot_inbox_manager/InboxManagerMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import FetchMessengerMessages from '@/plugins/graphql/queries/v3/fetch-messenger-messages.gql';
import InboxMessages from '@/plugins/graphql/subscriptions/v3/inbox-messages.gql';
import BaseInnerLoader from '@/components/v2/BaseInnerLoader';
import GeneratedResponse from '@/components/v3/inbox_manager/GeneratedResponse.vue';
import ProductListing from '@/components/v3/inbox_manager/ProductListing.vue';
import { AgentType } from '@/helpers/entities/enums/v3/Agent';
import { EventBus, EventBusTriggers } from '@/helpers/EventBus';
let MessengerMessages = class MessengerMessages extends Mixins(PaginatorMixin, InboxManagerMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.messages = [];
        this.sendingMessages = [];
        this.isFetchMore = false;
        this.originalContainerHeight = null;
        this.expandedMessages = {};
    }
    onMessagesChanged() {
        EventBus.$emit(EventBusTriggers.setAgentBreakdown, this.messages);
    }
    get messagesWithGenerations() {
        return this.messages
            .map((message) => {
            const list = [message];
            if (message.generatedResponse) {
                const msgobj = {
                    prompt: message.generatedResponse,
                    baseGlobalId: message.baseGlobalId,
                    sender: 'merchant',
                };
                list.push(msgobj);
            }
            return list;
        })
            .flat();
    }
    removePayload(messageList) {
        const filteredList = messageList.filter((message) => {
            if (message.message === '' &&
                message.products.length === 0 &&
                message.galleryPhotos.edges.length === 0) {
                return false;
            }
            return true;
        });
        return filteredList;
    }
    toggleExpand(index) {
        this.$set(this.expandedMessages, index, !this.expandedMessages[index]);
    }
    displayMessageImage(message) {
        if (message.galleryPhotos && message.galleryPhotos.edges.length > 0) {
            return message.galleryPhotos.edges[0].node.photoUrl;
        }
        return '';
    }
    fetchMessengerMessages() {
        this.shouldScrollToBottom = false;
        if (this.isFetchMore) {
            return; // Do not fetch more if already in progress
        }
        const { endCursor, hasNextPage } = this.pageInfo;
        if (hasNextPage) {
            this.isFetchMore = true; // Set flag to indicate fetch in progress
            this.$apollo
                .query({
                query: FetchMessengerMessages,
                variables: {
                    pageRecipientUuid: this.selectedRecipient.uuid,
                    first: 5,
                    after: endCursor,
                },
            })
                .then(({ data }) => {
                this.pageInfo = data.fetchMessengerMessages.pageInfo;
                const moreNodes = data.fetchMessengerMessages.edges.map((edge) => edge.node);
                const sortNodes = this.removePayload(moreNodes).slice().reverse();
                this.messages = [...sortNodes, ...this.messages];
                this.$nextTick(() => {
                    const container = this.$refs.messageContent;
                    const originalScrollTop = container.scrollTop;
                    this.$refs.messageContent.scrollTop =
                        originalScrollTop + sortNodes.length * this.getItemHeight();
                });
                this.isFetchMore = false;
            })
                .catch((err) => {
                console.log(err);
                this.isFetchMore = false;
            });
        }
        else {
            this.isFetchMore = false;
        }
    }
    handleScroll(event) {
        const element = this.$refs.messageContent;
        const { scrollTop } = element;
        if (scrollTop <= 0 && event.wheelDeltaY > 0) {
            this.fetchMessengerMessages();
        }
    }
    handleTouchScroll(event) {
        const list = event.target;
        const { scrollTop } = list;
        if (scrollTop <= 0) {
            // loadmore
            this.fetchMessengerMessages();
        }
    }
    showBreakdown(message) {
        // document.getElementsByClassName("breakdown-1")[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        EventBus.$emit(EventBusTriggers.setInboxWidgetTab, 1);
        setTimeout(() => {
            const target = document.getElementsByClassName(`breakdown-${message.baseGlobalId}`)[0];
            const container = document.getElementsByClassName('agent-breakdown')[0];
            const offset = target.offsetTop - container.scrollTop;
            container.scrollBy({ top: offset, behavior: 'smooth' });
        }, 250);
    }
    sendGeneration(event, baseGlobalId) {
        this.sendingMessages.push(event);
        this.shouldScrollToBottom = true;
        this.removeGeneration(baseGlobalId);
        this.shouldScrollToBottom = false;
    }
    removeGeneration(baseGlobalId) {
        const msgIndex = this.messages.findIndex((message) => message.baseGlobalId === baseGlobalId);
        this.$delete(this.messages[msgIndex], 'generatedResponse');
        if (this.shouldScrollToBottom) {
            this.scrollToBottom();
        }
    }
    getSentimentValue(message) {
        if (!message.agentBreakdown?.length)
            return null;
        const sentimentAnalysis = message?.agentBreakdown?.find((item) => item.type === AgentType.sentiment);
        return sentimentAnalysis?.jsonCompletion?.sentiment || null;
    }
    sendingMessageClassSelector() {
        if (this.testBot) {
            return 'merchant';
        }
        return 'merchant';
    }
    messageClassSelector(sender) {
        if (this.testBot && sender === 'merchant') {
            return 'customer';
        }
        if (this.testBot && sender === 'customer') {
            return 'merchant';
        }
        return sender;
    }
    mounted() {
        this.scrollToBottom();
        this.displayRecipientPhoto();
        EventBus.$on(EventBusTriggers.loadMessengerMessages, this.fetchMessengerMessages);
    }
    updated() {
        this.scrollToBottom();
    }
    beforeDestroy() {
        EventBus.$off(EventBusTriggers.loadMessengerMessages, this.fetchMessengerMessages);
    }
    receiveString(newString) {
        this.sendingMessages.push(newString);
    }
    deleteString() {
        this.sendingMessages.shift();
    }
};
__decorate([
    Prop({ type: String, required: true })
], MessengerMessages.prototype, "selectedFilter", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], MessengerMessages.prototype, "testBot", void 0);
__decorate([
    Watch('messages')
], MessengerMessages.prototype, "onMessagesChanged", null);
MessengerMessages = __decorate([
    Component({
        components: {
            BaseInnerLoader,
            GeneratedResponse,
            ProductListing,
        },
        apollo: {
            messages: {
                query: FetchMessengerMessages,
                variables() {
                    return {
                        pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                        first: 7,
                        after: this.startCursor,
                    };
                },
                skip() {
                    return !this.$store.state.selectedRecipient.uuid;
                },
                fetchPolicy: 'network-only',
                update({ fetchMessengerMessages }) {
                    const messageList = fetchMessengerMessages.edges.map((edge) => edge.node);
                    this.nodes = this.removePayload(messageList).reverse();
                    this.pageInfo = fetchMessengerMessages.pageInfo;
                    this.shouldScrollToBottom = true;
                    EventBus.$emit(EventBusTriggers.setAgentBreakdown, this.nodes);
                    return this.nodes;
                },
                subscribeToMore: {
                    document: InboxMessages,
                    variables() {
                        return {
                            pageRecipientGlobalId: this.$store.state.selectedRecipient.baseUuid,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        const { inboxMessage } = subscriptionData.data.inboxMessages;
                        if (inboxMessage.message === '' &&
                            inboxMessage.galleryPhotos.edges.length === 0 &&
                            inboxMessage.products.length === 0) {
                            return subscriptionData.data.inboxMessage;
                        }
                        // Find the original message and replace it with one with generated response if present
                        const foundMessageIndex = this.messages.findIndex((message) => message.baseGlobalId === inboxMessage.baseGlobalId);
                        if (foundMessageIndex !== -1) {
                            this.$set(this.messages, foundMessageIndex, inboxMessage);
                        }
                        else if (!inboxMessage.generatedResponse) {
                            // Only append if the inbox message has no generated response
                            // This means that the message is a new one, not one with a generation from AI
                            this.messages = [...this.messages, inboxMessage];
                        }
                        const foundSendingIndex = this.sendingMessages.findIndex((msg) => msg === inboxMessage.message);
                        if (foundSendingIndex !== -1) {
                            // Remove the message at foundSendingIndex from this.sendingMessages
                            this.sendingMessages.splice(foundSendingIndex, 1);
                        }
                        return subscriptionData.data.inboxMessages;
                    },
                },
            },
        },
    })
], MessengerMessages);
export default MessengerMessages;
